"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LABEL_DELTA = void 0;
exports.getLabelPoint = getLabelPoint;
exports.drawableMarkerCreateBinding = drawableMarkerCreateBinding;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var id_1 = require("../../id");
var model_1 = require("../../model");
var draw_state_1 = require("../draw.state");
var label_draw_svg_1 = require("../drawable/label.draw.svg");
var util_draw_svg_1 = require("../drawable/util.draw.svg");
var util_1 = require("../util");
exports.LABEL_DELTA = { x: 0, y: 50 };
function getLabelPoint(uiScale, resolution, marker) {
    var labelPoint = { x: resolution.width * 0.75, y: marker.y };
    return (0, util_1.movePoint)(labelPoint, exports.LABEL_DELTA, resolution, {
        width: label_draw_svg_1.LabelSVGDraw.Size.width * uiScale,
        height: label_draw_svg_1.LabelSVGDraw.height(1) * uiScale
    });
}
function createMarkerAt(dc, markerPoint, type) {
    if (type === void 0) { type = core_api_1.MarkerType.NONE; }
    var labelPoint = getLabelPoint(dc.state.scale, dc.capture.resolution, markerPoint);
    var marker = model_1.CollectionModelDrawableMarker.createWithLabel(dc.drawState, markerPoint, labelPoint, id_1.IkeId.generate(), type).marker;
    dc.state.setSelected(marker.id, util_draw_svg_1.IkeDrawLabel.LABEL);
    return marker.id;
}
function drawableMarkerCreateBinding(dc, evt) {
    var e_1, _a;
    if (dc.state.tool === draw_state_1.IkeDrawTool.BASE) {
        var drawableId = createMarkerAt(dc, evt.center, core_api_1.MarkerType.BASE);
        var drawable = dc.drawState.getDrawable(drawableId);
        // Base Marker's label are shown hard against the left edge
        drawable.label.move(0, drawable.label.y);
        dc.state.setTool(null);
        dc.state.setCrosshair(false);
        return;
    }
    if (evt.drawableId == null) {
        evt.drawableId = createMarkerAt(dc, evt.center);
    }
    var linkFieldIds = dc.state.linkFieldIds;
    if (linkFieldIds.length > 0) {
        var drawable = dc.drawState.getDrawable(evt.drawableId);
        if (!model_1.CollectionModelDrawableMarker.isNone(drawable)) {
            return;
        }
        try {
            for (var linkFieldIds_1 = tslib_1.__values(linkFieldIds), linkFieldIds_1_1 = linkFieldIds_1.next(); !linkFieldIds_1_1.done; linkFieldIds_1_1 = linkFieldIds_1.next()) {
                var linkFieldId = linkFieldIds_1_1.value;
                var field = dc.collection.findField(linkFieldId);
                if (!field) {
                    throw new Error("Unable to find field: ".concat(linkFieldId));
                }
                if (field instanceof model_1.CollectionModelFieldVerticalSeparation) {
                    field.Mutator.drawable(drawable);
                    drawable.label.linkVerticalSeparation(field);
                }
                else {
                    field.Mutator.drawable(drawable);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (linkFieldIds_1_1 && !linkFieldIds_1_1.done && (_a = linkFieldIds_1.return)) _a.call(linkFieldIds_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        dc.state.setLinkFields(null);
        dc.state.setSelected(drawable.id, util_draw_svg_1.IkeDrawLabel.LABEL);
        drawable.approveInsightFlag();
    }
    if (evt.$event != null) {
        evt.$event.preventDefault();
    }
}
//# sourceMappingURL=marker.create.binding.js.map